<script setup lang="ts">
import { ToccoSeminarFieldsFragment, ToccoSeminarTeaserFieldsFragment } from '~/api/graphql/generated'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  entity: ToccoSeminarFieldsFragment
}>()

const { t } = useI18n()

const relatedSeminars = computed(() => {
  if (!props.entity.fieldRelatedSeminars?.length) {
    return []
  }

  return props.entity.fieldRelatedSeminars
    .filter(Boolean)
    .map((item) => item.entity as ToccoSeminarTeaserFieldsFragment)
    .filter(Boolean)
    .map((entity) => ({
      title: entity.title || '',
      url: entity.entityUrl?.path || '',
      teaser: entity.fieldTeaser || '',
    }))
})
</script>

<template>
  <SectionSpecial v-if="relatedSeminars.length > 0" :title="t('tocco.detail.relatedSeminars')">
    <LinkListLarge>
      <template #default="{ isHovered }">
        <LinkListLargeItemEducationalOffering
          v-for="(item, index) of relatedSeminars"
          :key="index"
          v-animate="{ animation: 'vertical-reveal' }"
          :title="item.title"
          :link="{ url: item.url }"
          :dim="isHovered"
        />
      </template>
    </LinkListLarge>
  </SectionSpecial>
</template>
